import { useEffect } from "react";

import "../Style/NotFound.css"

function NotFound() {
    
    useEffect(()=>{
        document.title = "404 NotFound";
    });

    return (
        <div className="notfound">
            Page Not Found
        </div>
    );
}

export default NotFound;